<template>
<div>
    <ckeditor id="editor" :editor="editor" @ready="onReady" @input="updateSelf($event)" v-model="editorData" :config="editorConfig"></ckeditor>
</div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import Font from '@ckeditor/ckeditor5-font/src/font';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageResize from '@ckeditor/ckeditor5-image/src/imageresize';
import LinkImage from '@ckeditor/ckeditor5-link/src/linkimage';
import EasyImage from '@ckeditor/ckeditor5-easy-image/src/easyimage';
import CKFinder from '@ckeditor/ckeditor5-ckfinder/src/ckfinder';
import Base64UploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/base64uploadadapter';
import Table from '@ckeditor/ckeditor5-table/src/table'
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar'
import '@ckeditor/ckeditor5-build-classic/build/translations/ko';

export default {
    props: ['parentData'],
    data: () => ({
        editor: ClassicEditor,
        editorData: '',
        editorConfig: {
            plugins: [
                Table,
                TableToolbar,
                EssentialsPlugin,
                Bold,
                ItalicPlugin,
                LinkPlugin,
                ParagraphPlugin,
                Font,
                Alignment,
                Image, ImageToolbar, ImageCaption, ImageStyle, ImageResize, LinkImage,
                EasyImage,
                CKFinder,
                Base64UploadAdapter
            ],

            image: {
                styles: [
                    // This option is equal to a situation where no style is applied.
                    'full',

                    // This represents an image aligned to left.
                    'alignLeft',

                    // This represents an image aligned to right.
                    'alignRight'
                ],
                toolbar: ['imageTextAlternative', '|', 'imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight']
            },

            // 문단 정렬 (inline style 'text-align' 으로 저장됨, 기본값 left 는 속성 미생성)
            alignment: {
                options: ['left', 'center', 'right', 'justify']
            },

            language: 'ko',


        //     language: {
        //     // The UI will be English.
        //     ui: 'ko',

        //     // But the content will be edited in Arabic.
        //     content: 'ko'
        // },

            fontSize: {
                options: [
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    18,
                    20,
                    24,
                    28,
                    32,
                    36,
                    40
                ]
            },

            toolbar: {
                items: [
                    'fontFamily', 'fontSize', 'fontColor', 'fontBackgroundColor',
                    'alignment',
                    'bold',
                    'italic',
                    'link',
                    '|',
                    'undo',
                    'redo',
                    '|',
                    'imageStyle:full',
                    'imageStyle:alignLeft',
                    'imageStyle:alignRight',
                    'imageStyle:side',
                    'imageTextAlternative',
                    '|',
                    'insertTable','tableColumn', 'tableRow', 'mergeTableCells',
                    '|',
                    'linkImage',
                    'imageUpload'
                ]
            },
            // mergeTableCells: {
            //     options: [
            //         { model : 'check', title: 'check', view: 'h1'},
            //         { model : 'check2', title: 'check2', view: 'h2'},
            //         { model : 'check3', title: 'check3', view: 'h3'},
            //     ]
            // },

            styles: [
                // This option is equal to a situation where no style is applied.
                'full',

                // This represents an image aligned to the left.
                'alignLeft',

                // This represents an image aligned to the right.
                'alignRight'
            ]
            // cloudServices: {
            //     tokenUrl: 'https://example.com/cs-token-endpoint',
            //     uploadUrl: 'https://your-organization-id.cke-cs.com/easyimage/upload/'
            // }
        }
    }),

    mounted() {
        // ClassicEditor
        //     .create(document.querySelector('#editor'), {
        //         fontSize: {
        //             options: [
        //                 'tiny',
        //                 'default',
        //                 'big'
        //             ]
        //         },
        //         plugins: [Font], // <--- MODIFIED
        //         toolbar: ['fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor', 'undo', 'redo'] // <--- MODIFIED
        //     })
        //     .then(editor => {
        //         console.log('Editor was initialized', editor);
        //     })
        //     .catch(error => {
        //         console.error(error.stack);
        //     });
        console.log('editor1')
        console.log('this.parentData', this.parentData)
        // if (this.parentData) {
        //     this.editorData = this.parentData
        // }
    },

    // 에디터 사용하는 페이지에서 입력할때 데이터 감지하기 위한 코드
    watch: {
        parentData() {
            console.log('fessfefes')
            this.editorData = this.parentData
        }
    },

    computed() {
        console.log('computed')
        this.editorData = this.parentData
    },

    methods: {
        // CK에디터 입력받는 부분 업데이트
        updateSelf(event) {
            console.log('editor event', event)
            this.editorData = event
            this.$emit('input', this.editorData)
        },

        // CK에디터 렌더링 완료시 호출되는 함수 및 Toolbar 엘레멘트 활성화
        onReady(editor) {
            console.log('onready')
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        }
    }

}
</script>
